// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__BCHBW","placeholder":"Checkbox_placeholder__O-d5a","checkbox":"Checkbox_checkbox__S46yH","checkmark":"Checkbox_checkmark__Gjx9g"};